import { TownsServiceClient, LibraryLoginService } from '../../../generated/client';

export class LibraryLoginServiceFactory {
  private static _libraryLoginService: LibraryLoginService | undefined;

  constructor() {
    LibraryLoginServiceFactory._libraryLoginService = undefined;
  }

  public static instance() {
    const url = process.env.REACT_APP_TOWNS_SERVICE_URL;
    if (!LibraryLoginServiceFactory._libraryLoginService) {
      LibraryLoginServiceFactory._libraryLoginService = new TownsServiceClient({
        BASE: url,
      }).libraryLogin;
    }
    return LibraryLoginServiceFactory._libraryLoginService;
  }
}
